import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { getSession } from "./api/client";
import Layout    from "./components/Layout";
import Login     from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import GDPB      from "./pages/GDPB";
import GVC           from "./pages/GVC";
import GVCResultados from "./pages/GVCResultados";
import Modulos       from "./pages/Modulos";
import Shared        from "./pages/Shared";
import Configuracoes from "./pages/Configuracoes";
import GAV           from "./pages/GAV";
import MercadoAds    from "./pages/MercadoAds";

// A sessão é conferida no backend (cookie HttpOnly, ver app/auth.py) — o navegador só pergunta
function Private({ children }) {
  const [estado, setEstado] = useState("verificando");
  useEffect(() => {
    getSession().then(() => setEstado("ok")).catch(() => setEstado("sem_sessao"));
  }, []);
  if (estado === "verificando") return <div className="min-h-screen bg-gray-100" />;
  return estado === "ok" ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <Private>
              <Layout>
                <Routes>
                  <Route path="/"        element={<Dashboard />} />
                  <Route path="/gdpb"    element={<GDPB />} />
                  <Route path="/gvc"             element={<GVC />} />
                  <Route path="/gvc/resultados" element={<GVCResultados />} />
                  <Route path="/modulos"        element={<Modulos />} />
                  <Route path="/shared"         element={<Shared />} />
                  <Route path="/gav"            element={<GAV />} />
                  <Route path="/mercado-ads"    element={<MercadoAds />} />
                  <Route path="/configuracoes"  element={<Configuracoes />} />
                  <Route path="*"        element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </Private>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
